<div class="mt-8 mb-4">

    @let roles = (myRoles$ | async);
    @let group = (group$ | async);

    <div class="flex justify-between items-center w-full mb-4">

        <div class="flex flex-row justify-between w-full">
            <app-btn-back></app-btn-back>
            <div class="flex flex-row items-center gap-2">
                <app-btn-action label="Save Draft" bgColor="bg-transparent hover:bg-gray-200 active:bg-primary-500"
                    textColor="text-primary-500 active:text-white" [shadow]="false"
                    (clicked)="createQuiz(true)"></app-btn-action>
                <app-btn-action label="Create Quiz" bgColor="bg-primary-500 hover:bg-primary-700 active:bg-primary-500"
                    (clicked)="createQuiz(false)"></app-btn-action>
            </div>
        </div>

    </div>

    <div class="flex flex-col mb-4 border-0 w-full">

        <h1 class="font-semibold text-2xl text-primary-500">
            Schedule Quiz
        </h1>
        <span class="text-sm text-gray-500">Schedule a Quiz for participants to take at their convenience</span>

        <div class="w-full mx-auto mt-2 grid grid-cols-4 grid-rows-1 gap-4">

            <form [formGroup]="quizForm" class="col-span-full sm:col-span-3" (ngSubmit)="createQuiz()">

                <div
                    class="col-span-full sm:col-span-3 bg-white p-4 rounded-lg border border-gray-200 shadow-sm space-y-4">
                    <span class="text-sm text-primary-500 font-semibold items-center">Quiz Settings</span>
                    <div>
                        <label class="form-label">
                            Quiz Title *
                        </label>
                        <input type="text" formControlName="title" name="title"
                            class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150">
                    </div>
                    <div class="flex flex-row justify-between items-center w-full gap-4">
                        <div class="w-full">
                            <label class="form-label flex items-center gap-1">
                                <span>Start Date *</span>
                                <app-tooltip text="Quiz available after this date" position="top">
                                    <i
                                        class="fa fa-info-circle text-gray-300 hover:text-primary-500 cursor-pointer"></i>
                                </app-tooltip>
                            </label>
                            <input type="date" formControlName="startDate" name="startDate"
                                class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150">
                        </div>
                        <div class="w-full">
                            <label class="form-label flex items-center gap-1">
                                <span>End Date *</span>
                                <app-tooltip text="Quiz available until this date" position="top">
                                    <i
                                        class="fa fa-info-circle text-gray-300 hover:text-primary-500 cursor-pointer"></i>
                                </app-tooltip>
                            </label>
                            <input type="date" formControlName="endDate" name="endDate"
                                class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150">
                        </div>
                    </div>
                    <div class="flex flex-row justify-between items-center w-full gap-4">
                        <div class="w-full">
                            <label class="form-label flex items-center gap-1">
                                <span>Enable Time Limit *</span>
                                <app-tooltip text="Quiz should have a time limit" position="top">
                                    <i
                                        class="fa fa-info-circle text-gray-300 hover:text-primary-500 cursor-pointer"></i>
                                </app-tooltip>
                            </label>
                            <select formControlName="enableTimeLimit" id="enableTimeLimit" name="enableTimeLimit"
                                class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150">
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                        </div>
                        <div class="w-full">
                            <label class="form-label">
                                Total Time (Minutes) *
                            </label>
                            <input type="number" formControlName="totalDuration" name="totalDuration"
                                class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150 disabled:bg-gray-100 disabled:opacity-50">
                        </div>
                    </div>
                    <div class="flex flex-row justify-between items-center w-full gap-4">
                        <div class="w-full">
                            <label class="form-label flex items-center gap-1">
                                <span>Enable Scoring *</span>
                                <app-tooltip text="Quiz Participants Should See Scores" position="top">
                                    <i
                                        class="fa fa-info-circle text-gray-300 hover:text-primary-500 cursor-pointer"></i>
                                </app-tooltip>
                            </label>
                            <select formControlName="enableScoring" id="enableScoring" name="enableScoring"
                                class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150">
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                        </div>
                        <div class="w-full">
                            <label class="form-label flex items-center gap-1">
                                <span>Allow Multiple Attempts *</span>
                                <app-tooltip text="Participants Can Take The Quiz Multiple Times" position="top">
                                    <i
                                        class="fa fa-info-circle text-gray-300 hover:text-primary-500 cursor-pointer"></i>
                                </app-tooltip>
                            </label>
                            <select formControlName="allowMultipleAttempts" id="allowMultipleAttempts"
                                name="allowMultipleAttempts"
                                class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150">
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                        </div>
                    </div>
                    <div class="flex flex-row justify-between items-center w-full gap-4">
                        <div class="w-full">
                            <label class="form-label">
                                Quiz Access
                            </label>
                            <select type="byInvite" formControlName="byInvite" id="byInvite" name="byInvite"
                                class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150">
                                <option [ngValue]="true">By Invite</option>
                                <option [ngValue]="false">For all</option>
                            </select>
                        </div>
                        <div class="w-full">
                            <label class="form-label flex items-center gap-1">
                                <span>Text Answer Correctness % *</span>
                                <app-tooltip text="Minimum Correctness Percentage Required For Text Answers"
                                    position="top">
                                    <i
                                        class="fa fa-info-circle text-gray-300 hover:text-primary-500 cursor-pointer"></i>
                                </app-tooltip>
                            </label>
                            <input type="number" formControlName="shortAnswerPercentage" name="shortAnswerPercentage"
                                min="0" max="100"
                                class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 border-gray-300 text-primary-500 ease-linear transition-all duration-150">
                        </div>
                    </div>
                </div>

            </form>

            <div class="col-span-full sm:col-span-1 w-full h-full flex justify-between">
                <div
                    class="grid grid-cols-3 grid-rows-1 sm:grid-cols-1 sm:grid-rows-3 gap-4 text-center w-full items-center">
                    <div
                        class="flex flex-col justify-center p-4 border border-gray-200 bg-white rounded-lg h-full w-full">
                        <p class="text-2xl font-bold text-primary-500">{{selectedQuestions().length}}</p>
                        <p class="text-xs text-slate-500">Questions</p>
                    </div>
                    <div
                        class="flex flex-col justify-center p-4 border border-gray-200 bg-white rounded-lg h-full w-full">
                        <p class="text-2xl font-bold text-primary-500">{{totalScore()}}</p>
                        <p class="text-xs text-slate-500">Marks</p>
                    </div>
                    <div
                        class="flex flex-col justify-center p-4 border border-gray-200 bg-white rounded-lg h-full w-full">
                        <p class="text-2xl font-bold text-red-500">{{ isTimeLimitEnabled ?
                            (quizForm.get('totalDuration')?.value + ' m') : 'No Limit' }}</p>
                        <p class="text-xs text-slate-500">Duration</p>
                    </div>
                </div>
            </div>
        </div>

        @if ((roles.management || roles.faculty) && group?.memberStatus === membershipStatus.active) {
        <div class="flex flex-row flex-nowrap gap-4 h-[600px] mt-4 w-full">

            <div class="flex flex-col w-full bg-white border border-gray-200 rounded-lg p-4">

                <div class="flex flex-row justify-between">
                    <span class="text-sm font-semibold text-primary-400">Selected Questions</span>
                    <span (click)="toggleSearch()"
                        class="text-xs cursor-pointer text-primary-300 hover:text-primary-500"><i
                            class="fa fa-add mr-1"></i> Add
                        Questions</span>
                </div>

                <div class="flex-1 overflow-y-auto touch-none flex flex-col gap-2 mt-4">
                    @for (item of selectedQuestions(); track item.id; let i = $index) {
                    <div class="flex flex-row items-start gap-2">
                        <span class="text-sm text-gray-500 w-8 text-right py-2"># {{i + 1}}</span>
                        <div
                            class="flex flex-col gap-1 w-full p-2 rounded-md touch-none cursor-pointer shadow-sm border bg-white border-gray-200">
                            <span class="text-sm font-medium text-gray-700">{{ item.questionText }}</span>
                            <div class="flex flex-row gap-2">
                                <app-chip [label]="item.questionType" [color]="chipColor.PRIMARY"></app-chip>
                                <app-chip [label]="item.score + ' marks'" [color]="chipColor.LIGHT"></app-chip>
                                <app-chip class="titlecase"
                                    [label]="item.reference.book + ' ' + item.reference.chapter + (item.reference.verse ? (':' + item.reference.verse) : '')"
                                    [color]="chipColor.LIGHT"></app-chip>
                            </div>
                        </div>
                        <app-btn-fab (click)="removeQuestion(item)" bgColor="bg-white hover:bg-red-500"
                            textColor="text-red-500 hover:text-white" [icon]="'fas fa-trash'"></app-btn-fab>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
    </div>

    @if (showSearch) {
    <div class="fixed inset-0 z-50 flex" [class.items-end]="isMobile" [class.justify-end]="!isMobile">

        <div @fade (click)="toggleSearch()"
            class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity">
        </div>

        <div [@slideInOut]="animationParams"
            class="relative bg-white shadow-2xl transition-all duration-300 overflow-hidden" [class.w-full]="isMobile"
            [class.h-[80vh]]="isMobile" [class.rounded-t-[32px]]="isMobile" [class.w-[550px]]="!isMobile"
            [class.h-full]="!isMobile">

            <div class="flex flex-col h-full w-full p-4">

                <span class="text-md font-semibold text-primary-400">Search & Add Questions</span>
                <span class="text-sm text-primary-300 mb-2">Search and add existing questions from your Question
                    Bank</span>

                <app-question-search [groupId]="groupId" [showTagsFilter]="true" [showTextFilter]="true"
                    (searchResults)="onSearchResults($event)" (searchCleared)="onSearchCleared()">
                </app-question-search>

                <div class="flex-1 overflow-y-auto touch-none flex flex-col gap-2">
                    @for (item of searchedQuestions$ | async; track item.id) {
                    <div class="flex flex-row items-start gap-2">
                        @let isSelected = isQuestionSelected(item.id);
                        <div (click)="toggleQuestion(item, !isSelected)"
                            class="flex flex-col gap-1 w-full p-2 rounded-md touch-none cursor-move shadow-sm border"
                            [class]="isSelected ? 'border-green-500 bg-green-100 hover:border-gray-200 hover:bg-gray-100' : 'bg-white border-gray-200 hover:bg-gray-100 hover:border-gray-200'">
                            <span class="text-sm font-medium text-gray-700">{{ item.questionText }}</span>
                            <div class="flex flex-row gap-2">
                                <app-chip [label]="item.questionType" [color]="chipColor.PRIMARY"></app-chip>
                                <app-chip [label]="item.score + ' marks'" [color]="chipColor.LIGHT"></app-chip>
                                <app-chip class="titlecase"
                                    [label]="item.reference.book + ' ' + item.reference.chapter + (item.reference.verse ? (':' + item.reference.verse) : '')"
                                    [color]="chipColor.LIGHT"></app-chip>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    }